export { default as General } from 'notifications_historic/components/form/sections/NotificationHistoricFormGeneral';
export { default as Depreciations } from 'notifications_historic/components/form/sections/NotificationHistoricFormDepreciations';
export { default as Users } from 'notifications_historic/components/form/sections/NotificationHistoricFormUsers';
export { default as Elements } from 'notifications_historic/components/form/sections/NotificationHistoricFormElements';
export { default as UsersTable } from 'notifications_historic/components/form/sections/NotificationHistoricFormUsersTable';
export { default as UserRow } from 'notifications_historic/components/form/sections/NotificationHistoricFormUserRow';
export { default as UsersToNotifyTable } from 'notifications_historic/components/form/sections/NotificationHistoricFormUsersToNotifyTable';
export { default as UserToNotifyRow } from 'notifications_historic/components/form/sections/NotificationHistoricFormUserToNotifyRow';



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/form/sections/index.js